const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/components/Buttons/SublimdButton.tsx';
import React from 'react';
import { Button } from '@mui/material';
import { useIntl } from 'react-intl';
import textMap from 'App/components/Buttons/translations';
import { goToSublimdIFrame } from 'App/utils/history';
import { useHistory } from 'react-router';

interface Props {
    termNr: string;
}

export const SublimdBtn = (props: Props) => {
    const { termNr } = props;
    const { formatMessage } = useIntl();
    const history = useHistory();

    const handleButtonClick = () => {
        goToSublimdIFrame(history, termNr);
    };

    return (
        <Button
            variant="contained"
            startIcon={<span className={'icons8-questionnaire'} />}
            key={`sublimd-${termNr}`}
            onClick={handleButtonClick}
            color={'primary'}
            size={'small'}
        >
            {formatMessage(textMap.questionnaire)}
        </Button>
    );
};
